export const isEmpty = <T>(value: unknown): value is T => {
  const typeOfValue = typeof value;

  if (['undefined', null].indexOf(typeOfValue) >= 0) {
    return true;
  }

  if (typeOfValue === 'string' && !value) {
    return true;
  }

  if (typeOfValue === 'object') {
    if (value instanceof Function) {
      return false;
    }
    if(value instanceof Array && !Object.keys(value).length) {
      return true;
    }
  }

  return false;

}
